import React, {useState} from "react";
import {Pause, Play, Trash2} from "lucide-react";
import SeriesEditModal from "./SeriesEditModal";

const MySeriesTableBody = ({
                               series,
                               handleSeriesAction,
                               setSelectedSeries,
                               languages,
                               themes
                           }) => {
    const [editingSeries, setEditingSeries] = useState(null);

    const handleSave = (updatedSeries) => {
        handleSeriesAction(updatedSeries._id, 'update', updatedSeries);
        setEditingSeries(null);
    };

    return (
        <>
            <tbody>
            {series.map((seriesItem) => (
                <tr key={seriesItem._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">{seriesItem.theme.theme}</td>
                    <td className="px-6 py-4">{seriesItem.status}</td>
                    <td className="px-6 py-4">{seriesItem.language}</td>
                    <td className="px-6 py-4">{seriesItem.platforms.join(', ')}</td>
                    <td className="px-6 py-4">{seriesItem.voice}</td>
                    <td className="px-6 py-4">
                        {new Date(seriesItem.createdAt).toLocaleString()}
                    </td>
                    <td className="px-6 py-4 space-x-2">
                        {/*{seriesItem.status === 'Active' && (*/}
                        {/*    <button*/}
                        {/*        className="p-2 hover:bg-gray-100 rounded-full"*/}
                        {/*        onClick={() => setEditingSeries(seriesItem)}*/}
                        {/*    >*/}
                        {/*        <Pencil className="h-4 w-4" />*/}
                        {/*    </button>*/}
                        {/*)}*/}
                        <button
                            className="p-2 hover:bg-gray-100 rounded-full"
                            onClick={() => {
                                // setSelectedSeries(seriesItem);
                                handleSeriesAction(
                                    seriesItem._id,
                                    seriesItem.status === 'Active' ? 'pause' : 'resume'
                                );
                            }}
                        >
                            {seriesItem.status === 'Active' ? (
                                <Pause className="h-4 w-4" />
                            ) : (
                                <Play className="h-4 w-4" />
                            )}
                        </button>
                        <button
                            className="p-2 hover:bg-gray-100 rounded-full"
                            onClick={() =>
                                handleSeriesAction(
                                    seriesItem._id,
                                    'delete',
                                    seriesItem.theme.theme
                                )
                            }
                        >
                            <Trash2 className="h-4 w-4" />
                        </button>
                    </td>
                </tr>
            ))}
            </tbody>
            {editingSeries && (
                <SeriesEditModal
                    series={editingSeries}
                    onSave={handleSave}
                    onClose={() => setEditingSeries(null)}
                    languages={languages}
                    themes={themes}
                />
            )}
        </>
    );
};

export default MySeriesTableBody;